import styled from "styled-components";
 

 export const getResponsiveStyle = (props: any, key: string, fallback: string = '') => {
  return props?.component_styles?.mobile?.[key]
    || props?.component_styles?.computer?.[key]
    || fallback;
}

export const Image = styled.div<any>`
  width: ${props => props?.component_styles?.computer?.image_size || '200px'} !important;
  height: ${props => props?.component_styles?.computer?.image_size || '200px'} !important;
  border-radius: ${props => props?.component_styles?.computer?.image_border_radius || '0px'} !important;

  background: url("${props => props?.src}") no-repeat center top;
  background-size: cover;

  @media (max-width: 750px) {
    width: ${props => getResponsiveStyle(props, 'image_size', '200px')} !important;
     height: ${props => getResponsiveStyle(props, 'image_size', '200px')} !important;
    border-radius: ${props => getResponsiveStyle(props, 'image_border_radius', '0px')} !important;
  }
`;

export const ImageProgram = styled.div<any>`
min-width: ${props => props?.component_styles?.computer?.program_image_size || '200px'} !important;
  width: ${props => props?.component_styles?.computer?.program_image_size || '200px'} !important;
  height: ${props => props?.component_styles?.computer?.program_image_size || '200px'} !important;
  border-radius: ${props => props?.component_styles?.computer?.program_image_border_radius || '0px'} !important;

  background: url("${props => props?.src}") no-repeat center top;
  background-size: cover;

  @media (max-width: 750px) {
    width: ${props => getResponsiveStyle(props, 'program_image_size', '200px')} !important;
     height: ${props => getResponsiveStyle(props, 'program_image_size', '200px')} !important;
    border-radius: ${props => getResponsiveStyle(props, 'program_image_border_radius', '0px')} !important;
  }
`;

export const BigTitle = styled.h3<any>`
width: 100%;
  font-size: ${props => props?.component_styles?.computer?.big_title_size || '18px'} !important;
  line-height: ${props => props?.component_styles?.computer?.big_title_line_height || '22px'} !important;
  background: ${props => props?.component_styles?.computer?.big_title_background || 'none'} !important;  
  color: ${props => props?.component_styles?.computer?.big_title_color || 'none'} !important; 
  text-align: ${props => props?.component_styles?.computer?.big_title_text_align || 'left'} !important; 
 p,strong,h1,h2,h3{
 color: ${props => props?.component_styles?.computer?.big_title_color || 'none'} !important; 
 
    }
  @media (max-width: 750px) {
    font-size: ${props => getResponsiveStyle(props, 'big_title_size', '18px')} !important;
    line-height: ${props => getResponsiveStyle(props, 'big_title_line_height', '22px')} !important;
    background: ${props => getResponsiveStyle(props, 'big_title_background', 'none')} !important;
    color: ${props => getResponsiveStyle(props, 'big_title_color', 'none')} !important;
    text-align: ${props => getResponsiveStyle(props, 'big_title_text_align', 'left')} !important;
  }
`;

export const BigDescription = styled.h3<any>`
width: 100%;
  font-size: ${props => props?.component_styles?.computer?.big_description_size || '18px'} !important;
  line-height: ${props => props?.component_styles?.computer?.big_description_line_height || '22px'} !important;
  background: ${props => props?.component_styles?.computer?.big_description_background || 'none'} !important;  
  color: ${props => props?.component_styles?.computer?.big_description_color || 'none'} !important; 
  text-align: ${props => props?.component_styles?.computer?.big_description_text_align || 'left'} !important; 
 p,strong,h1,h2,h3{
 color: ${props => props?.component_styles?.computer?.big_description_color || 'none'} !important; 
 
    }
  @media (max-width: 750px) {
    font-size: ${props => getResponsiveStyle(props, 'big_description_size', '18px')} !important;
    line-height: ${props => getResponsiveStyle(props, 'big_description_line_height', '22px')} !important;
    background: ${props => getResponsiveStyle(props, 'big_description_background', 'none')} !important;
    color: ${props => getResponsiveStyle(props, 'big_description_color', 'none')} !important;
    text-align: ${props => getResponsiveStyle(props, 'big_description_text_align', 'left')} !important;
  }
`;

export const Title = styled.p<any>`
width: 100%;
font-weight: bold;
  font-size: ${props => props?.component_styles?.computer?.title_size || '18px'} !important;
  line-height: ${props => props?.component_styles?.computer?.title_line_height || '22px'} !important;
  background: ${props => props?.component_styles?.computer?.title_background || 'none'} !important;  
  color: ${props => props?.component_styles?.computer?.title_color || 'none'} !important; 
  text-align: ${props => props?.component_styles?.computer?.title_text_align || 'left'} !important; 
    padding: ${props => props?.component_styles?.computer?.title_padding || '15px'} !important; 


    p,strong,h1,h2,h3{
 color: ${props => props?.component_styles?.computer?.title_color || '#333'} !important; 
 
    }

  @media (max-width: 750px) {
    font-size: ${props => getResponsiveStyle(props, 'title_size', '18px')} !important;
    line-height: ${props => getResponsiveStyle(props, 'title_line_height', '22px')} !important;
    background: ${props => getResponsiveStyle(props, 'title_background', 'none')} !important;
    color: ${props => getResponsiveStyle(props, 'title_color', 'none')} !important;
    text-align: ${props => getResponsiveStyle(props, 'title_text_align', 'left')} !important;
        padding: ${props => getResponsiveStyle(props, 'title_padding', '15px')} !important;
  }
`;

export const Category = styled.p<any>`
width: auto;
 
  line-height: ${props => props?.component_styles?.computer?.category_line_height || '18px'} !important;
  background: ${props => props?.background || props?.component_styles?.computer?.category_background || 'none'} !important;  
  color: ${props => props?.color || props?.component_styles?.computer?.category_background || 'none'} !important; 
  text-align: ${props => props?.component_styles?.computer?.category_text_align || 'left'} !important; 
  padding: ${props => props?.component_styles?.computer?.category_padding || '5px 15px'} !important; 
    border-radius: ${props => props?.component_styles?.computer?.category_border_radius || '5px'} !important; 
  @media (max-width: 750px) {
    font-size: ${props => getResponsiveStyle(props, 'category_size', '14px')} !important;
    line-height: ${props => getResponsiveStyle(props, 'category_line_height', '18px')} !important;
    text-align: ${props => getResponsiveStyle(props, 'category_text_align', 'left')} !important;
    padding: ${props => getResponsiveStyle(props, 'category_padding', '5px 15px')} !important;
        border-radius: ${props => getResponsiveStyle(props, 'category_border_radius', '5px')} !important;
  }
`;





export const SearchContainer = styled.p<any>`
width: auto;
  font-size: ${props => props?.component_styles?.computer?.search_size || '14px'} !important;
  line-height: ${props => props?.component_styles?.computer?.search_line_height || '18px'} !important;
  background: ${props => props?.component_styles?.computer?.search_background || 'none'} !important;  
  color: ${props => props?.component_styles?.computer?.search_color || '#333'} !important; 
  text-align: ${props => props?.component_styles?.computer?.search_text_align || 'left'} !important; 
  padding: ${props => props?.component_styles?.computer?.search_padding || '10px 0px'} !important; 

  input,select {
  min-height : 43px;
  padding: 10px 16px;
  border-radius: 5px;
  max-width: 300px;
  }


  @media (max-width: 750px) {
    font-size: ${props => getResponsiveStyle(props, 'search_size', '14px')} !important;
    line-height: ${props => getResponsiveStyle(props, 'search_line_height', '18px')} !important;
    background: ${props => getResponsiveStyle(props, 'search_background', 'none')} !important;
    color: ${props => getResponsiveStyle(props, 'search_color', '#333')} !important;
    text-align: ${props => getResponsiveStyle(props, 'search_text_align', 'left')} !important;
    padding: ${props => getResponsiveStyle(props, 'search_padding', '10px 0px')} !important;
  }
`;

export const DateContainer = styled.p<any>`
width: auto;
  font-size: ${props => props?.component_styles?.computer?.date_size || '14px'} !important;
  line-height: ${props => props?.component_styles?.computer?.date_line_height || '18px'} !important;
  background: ${props => props?.component_styles?.computer?.date_background || 'none'} !important;  
  color: ${props => props?.component_styles?.computer?.date_color || '#333'} !important; 
  text-align: ${props => props?.component_styles?.computer?.date_text_align || 'left'} !important; 
  padding: ${props => props?.component_styles?.computer?.date_padding || '10px 0px'} !important; 
  @media (max-width: 750px) {
    font-size: ${props => getResponsiveStyle(props, 'date_size', '14px')} !important;
    line-height: ${props => getResponsiveStyle(props, 'date_line_height', '18px')} !important;
    background: ${props => getResponsiveStyle(props, 'date_background', 'none')} !important;
    color: ${props => getResponsiveStyle(props, 'date_color', '#333')} !important;
    text-align: ${props => getResponsiveStyle(props, 'date_text_align', 'left')} !important;
    padding: ${props => getResponsiveStyle(props, 'date_padding', '10px 0px')} !important;
  }
`;


export const Paragraph = styled.p<any>`
width: 100%;
  font-size: ${props => props?.component_styles?.computer?.description_size || '18px'} !important;
  line-height: ${props => props?.component_styles?.computer?.description_line_height || '22px'} !important;
  background: ${props => props?.component_styles?.computer?.description_background || 'none'} !important;  
  color: ${props => props?.component_styles?.computer?.description_color || 'none'} !important; 
  text-align: ${props => props?.component_styles?.computer?.description_text_align || 'left'} !important; 
  padding: ${props => props?.component_styles?.computer?.description_padding || '10px 15px'} !important; 

 p,strong,a,h1,h2,h3{
 color: ${props => props?.component_styles?.computer?.description_color || '#333'} !important; 
 
    }

  @media (max-width: 750px) {
    font-size: ${props => getResponsiveStyle(props, 'description_size', '18px')} !important;
    line-height: ${props => getResponsiveStyle(props, 'description_line_height', '22px')} !important;
    background: ${props => getResponsiveStyle(props, 'description_background', 'none')} !important;
    color: ${props => getResponsiveStyle(props, 'description_color', 'none')} !important;
    text-align: ${props => getResponsiveStyle(props, 'description_text_align', 'left')} !important;
    padding: ${props => getResponsiveStyle(props, 'description_padding', '10px 15px')} !important;
  }
`;

export const TextContainer = styled.div<any>`
width: 100%;
  display: flex;
  flex-direction: ${props => props?.component_styles?.computer?.text_container_flex_direction || 'column'} !important;
  align-items: ${props => props?.component_styles?.computer?.text_container_align_items || 'flex-start'} !important;
  justify-content: ${props => props?.component_styles?.computer?.text_container_justify_content || 'flex-start'} !important;
  width: ${props => props?.component_styles?.computer?.text_container_width || '100%'} !important;
  padding: ${props => props?.component_styles?.computer?.text_container_padding || '24px'} !important;
  gap: ${props => props?.component_styles?.computer?.text_container_gap || '16px'} !important;
  background: ${props => props?.component_styles?.computer?.text_container_background || 'none'} !important;
  border: ${props => props?.component_styles?.computer?.text_container_border_radius || '0px'} !important;
 max-width:  100% !important;


  @media (max-width: 750px) {
    flex-direction: ${props => getResponsiveStyle(props, 'text_container_flex_direction', 'column')} !important;
    align-items: ${props => getResponsiveStyle(props, 'text_container_align_items', 'flex-start')} !important;
    justify-content: ${props => getResponsiveStyle(props, 'text_container_justify_content', 'flex-start')} !important;
    width: ${props => getResponsiveStyle(props, 'text_container_width', '100%')} !important;
    padding: ${props => getResponsiveStyle(props, 'text_container_padding', '24px')} !important;
    gap: ${props => getResponsiveStyle(props, 'text_container_gap', '16px')} !important;
    background: ${props => getResponsiveStyle(props, 'text_container_background', 'none')} !important;
    border: ${props => getResponsiveStyle(props, 'text_container_border_radius', '0px')} !important;
  }
`;

export const BlockContainer = styled.div<any>`
  display: flex;
  flex-direction: ${props => props?.component_styles?.computer?.container_flex_direction || 'row'} !important;
  align-items: ${props => props?.component_styles?.computer?.container_align_items || 'flex-start'} !important;
  justify-content: ${props => props?.component_styles?.computer?.container_justify_content || 'flex-start'} !important;
  width: ${props => props?.component_styles?.computer?.container_width || '100%'} !important;
  max-width:  100% !important;
  padding: ${props => props?.component_styles?.computer?.container_padding || '0px'} !important;
  gap: ${props => props?.component_styles?.computer?.container_gap || '16px'} !important;
  background: ${props => props?.component_styles?.computer?.container_background || 'none'} !important;
  border: ${props => props?.border || props?.component_styles?.computer?.container_border || '0px'} !important;
  border-radius: ${props => props?.component_styles?.computer?.container_border_radius || '0px'} !important;

  @media (max-width: 750px) {
    flex-direction: ${props => getResponsiveStyle(props, 'container_flex_direction', 'column')} !important;
    align-items: ${props => getResponsiveStyle(props, 'container_align_items', 'flex-start')} !important;
    justify-content: ${props => getResponsiveStyle(props, 'container_justify_content', 'flex-start')} !important;
    width: ${props => getResponsiveStyle(props, 'container_width', '100%')} !important;
    padding: ${props => getResponsiveStyle(props, 'container_padding', '0px')} !important;
    gap: ${props => getResponsiveStyle(props, 'container_gap', '16px')} !important;
    background: ${props => getResponsiveStyle(props, 'container_background', 'none')} !important;
  
    border-radius: ${props => getResponsiveStyle(props, 'container_border_radius', '0px')} !important;
  }
`;

export const BlockInternalContainer = styled.div<any>`
  display: flex;
  flex-direction: ${props => props?.component_styles?.computer?.internal_container_flex_direction || 'row'} !important;
  align-items: ${props => props?.component_styles?.computer?.internal_container_align_items || 'flex-start'} !important;
  justify-content: ${props => props?.component_styles?.computer?.internal_container_justify_content || 'flex-start'} !important;
  width: ${props => props?.component_styles?.computer?.internal_container_width || '100%'} !important;
  padding: ${props => props?.component_styles?.computer?.internal_container_padding || '0px'} !important;
  gap: ${props => props?.component_styles?.computer?.internal_container_gap || '16px'} !important;
  background: ${props => props?.component_styles?.computer?.internal_container_background || 'none'} !important;
  border: ${props => props?.component_styles?.computer?.internal_container_border || '0px'} !important;
  border-radius: ${props => props?.component_styles?.computer?.internal_container_border_radius || '0px'} !important;
 max-width:  100% !important;
  @media (max-width: 750px) {
    flex-direction: ${props => getResponsiveStyle(props, 'internal_container_flex_direction', 'column')} !important;
    align-items: ${props => getResponsiveStyle(props, 'internal_container_align_items', 'flex-start')} !important;
    justify-content: ${props => getResponsiveStyle(props, 'internal_container_justify_content', 'flex-start')} !important;
    width: ${props => getResponsiveStyle(props, 'internal_container_width', '100%')} !important;
    padding: ${props => getResponsiveStyle(props, 'internal_container_padding', '0px')} !important;
    gap: ${props => getResponsiveStyle(props, 'internal_container_gap', '16px')} !important;
    background: ${props => getResponsiveStyle(props, 'internal_container_background', 'none')} !important;
    border: ${props => getResponsiveStyle(props, 'internal_container_border', '0px')} !important;
    border-radius: ${props => getResponsiveStyle(props, 'internal_container_border_radius', '0px')} !important;
  }
`;

export const BlockExternalContainer = styled.div<any>`
  display: flex;
  flex-direction: ${props => props?.component_styles?.computer?.external_container_flex_direction || 'row'} !important;
  align-items: ${props => props?.component_styles?.computer?.external_container_align_items || 'flex-start'} !important;
  justify-content: ${props => props?.component_styles?.computer?.external_container_justify_content || 'flex-start'} !important;
  width: ${props => props?.component_styles?.computer?.external_container_width || '100%'} !important;
   max-width:  100% !important;
  padding: ${props => props?.component_styles?.computer?.external_container_padding || '0px'} !important;
  gap: ${props => props?.component_styles?.computer?.external_container_gap || '16px'} !important;
  background: ${props => props?.component_styles?.computer?.external_container_background || 'none'} !important;
  border: ${props => props?.component_styles?.computer?.external_container_border || '0px'} !important;
  border-radius: ${props => props?.component_styles?.computer?.external_container_border_radius || '0px'} !important;

  @media (max-width: 750px) {
    flex-direction: ${props => getResponsiveStyle(props, 'external_container_flex_direction', 'column')} !important;
    align-items: ${props => getResponsiveStyle(props, 'external_container_align_items', 'flex-start')} !important;
    justify-content: ${props => getResponsiveStyle(props, 'external_container_justify_content', 'flex-start')} !important;
    width: ${props => getResponsiveStyle(props, 'external_container_width', '100%')} !important;
    padding: ${props => getResponsiveStyle(props, 'external_container_padding', '0px')} !important;
    gap: ${props => getResponsiveStyle(props, 'external_container_gap', '16px')} !important;
    background: ${props => getResponsiveStyle(props, 'external_container_background', 'none')} !important;
    border: ${props => getResponsiveStyle(props, 'external_container_border', '0px')} !important;
    border-radius: ${props => getResponsiveStyle(props, 'external_container_border_radius', '0px')} !important;
  }
`;


export const BlockContainerModal = styled.div<any>`
  display: flex;
  flex-direction: row  !important;
  align-items: ${props => props?.component_styles?.computer?.container_align_items || 'flex-start'} !important;
  justify-content: ${props => props?.component_styles?.computer?.container_justify_content || 'flex-start'} !important;
  width: ${props => props?.component_styles?.computer?.container_width || '100%'} !important;
  padding: ${props => props?.component_styles?.computer?.container_padding || '24px'} !important;
  gap: ${props => props?.component_styles?.computer?.container_gap || '16px'} !important;
  background: ${props => props?.component_styles?.computer?.container_background || 'none'} !important;
  border: ${props => props?.component_styles?.computer?.container_border || '0px'} !important;
  border-radius: ${props => props?.component_styles?.computer?.container_border_radius || '0px'} !important;

  @media (max-width: 750px) {
    flex-direction:  column !important;
    align-items: ${props => getResponsiveStyle(props, 'container_align_items', 'flex-start')} !important;
    justify-content: ${props => getResponsiveStyle(props, 'container_justify_content', 'flex-start')} !important;
    width: ${props => getResponsiveStyle(props, 'container_width', '100%')} !important;
    padding: ${props => getResponsiveStyle(props, 'container_padding', '24px')} !important;
    gap: ${props => getResponsiveStyle(props, 'container_gap', '16px')} !important;
    background: ${props => getResponsiveStyle(props, 'container_background', 'none')} !important;
    border: ${props => getResponsiveStyle(props, 'container_border', '0px')} !important;
    border-radius: ${props => getResponsiveStyle(props, 'container_border_radius', '0px')} !important;
  }
`;